import React, { Component } from 'react'
import PropTypes from 'prop-types'
import merge from 'lodash/merge'
import { Container } from 'components/layout/Grid/'
import RouteWithSubRoutes from 'components/RouteWithSubRoutes'
import { resetErrorMessage, setErrorMessage } from 'actions/app'
import { getPartnerPlans, setSelectedPlan, initHtmlPageContent, updatePartnerPlanStatus } from 'actions/partnerPlans'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import constants from 'constants'
import { hasAccess } from 'utils/hasAccess'
import { getPathName } from 'utils/getPathName'
import { getEmployeeId } from 'utils/getEmployeeId'
import { getConfig } from 'utils/config'
import Loading from 'components/Loading'
import { commonFunctions } from 'utils/CommonFunctions'
import { getFiscalYearTimestamps } from 'utils/fiscalYear'

class MyPartnerPlans extends Component {
  static propTypes = {
    currentUser: PropTypes.object.isRequired,
    // getPageHtmlContent: PropTypes.func.isRequired,
    getPartnerPlans: PropTypes.func.isRequired,
    history: PropTypes.func.isRequired,
    initHtmlPageContent: PropTypes.func.isRequired,
    partnerPlans: PropTypes.object,
    routes: PropTypes.instanceOf(Array),
    selectedPartner: PropTypes.object,
    setErrorMessage: PropTypes.func.isRequired,
    setSelectedPlan: PropTypes.func.isRequired,
    updatePartnerPlanStatus: PropTypes.func.isRequired,
  }
  static defaultProps = {
    routes: {},
    partnerPlans: null,
    selectedPartner: null,
  }

  constructor(props) {
    super(props)
    this.state = {
      loadMore: false,
    }
  }

  componentWillMount() {
    this.props.initHtmlPageContent()
  }

  componentDidMount() {
    hasAccess(this.props.currentUser, 'Partner Plan', this.props.history)
    this.props.getPartnerPlans(
      constants.PARTNERPLAN.VIEW.MYPLANS,
      getEmployeeId(this.props.selectedPartner, this.props.currentUser),
    )
    // this.props.getPageHtmlContent(getConfig().PAGE_TEMPLATE_LIBRARY, 'PartnerPlanSideNav', this.props.currentUser.EmployeeId)
  }

  handleLoadMore = () => {
    this.setState(prevState => ({
      loadMore: !prevState.loadMore,
    }), () => {
      this.props.getPartnerPlans(
        constants.PARTNERPLAN.VIEW.MYPLANS,
        getEmployeeId(this.props.selectedPartner, this.props.currentUser),
        !this.props.currentUser.IsAdmin,
        (this.state.loadMore === true ? constants.PARTNERPLAN.PLAN_FILTER_ADMIN_YEAR : (getFiscalYearTimestamps().current.year - constants.PARTNERPLAN.PLAN_FILTER_PARTNER_YEAR)),
      )
    })
    /*
    if (this.state.loadMore === true) {
      this.setState({ loadMore: false }, () => {  })
      // setTimeout(() => { this.setState({ this.props.modalShow(id) }) }, 500)
    } else {
      this.setState({ loadMore: true }, () => {  })
      setTimeout(() => { this.setState({ loadMore: true }) }, 500)
    } */
  }

  handleIsLoadMore = () => {
    return this.state.loadMore
  }

  handleSelectedPlan = (plan) => {
    // BRD-PP-039 and BRD-PP-022 update plan status and automatically moved it to the next phase (only applies if plan is on plan agreed or interim assessment agreed)
    if (plan.PlanStatus === constants.PARTNERPLAN.STATUS.INTERIM_ASSESSMENT_AGREED || plan.PlanStatus === constants.PARTNERPLAN.STATUS.AGREED) {
      this.props.updatePartnerPlanStatus(
        plan.EmployeeId, plan.PlanYear,
        (plan.PlanStatus === constants.PARTNERPLAN.STATUS.INTERIM_ASSESSMENT_AGREED
          ? constants.PARTNERPLAN.STATUS.FINAL_ASSESSMENT
          : constants.PARTNERPLAN.STATUS.INTERIM_ASSESSMENT), (commonFunctions.isAdminPortal() ? constants.PARTNERPLAN.MODIFIED_BY_ADMIN : commonFunctions.iff(
          (this.props.currentUser.GivenName && this.props.currentUser.Surname),
          `${this.props.currentUser.GivenName} ${this.props.currentUser.Surname}`, this.props.currentUser.DisplayName,
        )),
      )
      // update selected plan status
      const updatedPlan = merge({}, plan, {
        PlanStatus: (plan.PlanStatus === constants.PARTNERPLAN.STATUS.INTERIM_ASSESSMENT_AGREED
          ? constants.PARTNERPLAN.STATUS.FINAL_ASSESSMENT
          : constants.PARTNERPLAN.STATUS.INTERIM_ASSESSMENT),
      })
      this.props.setSelectedPlan(updatedPlan)
    } else {
      this.props.setSelectedPlan(plan)
    }
    const pathName = `${getPathName(this.props.currentUser, '/partnerplan/plan')}`
    this.props.history.push({ pathname: pathName })
  }

  render() {
    const {
      routes, currentUser, partnerPlans, selectedPartner,
    } = this.props
    if (this.props.partnerPlans.isFetching) {
      return (<Loading pageLoading />)
    }
    return (
      <Container>
        {routes.map((route, i) => (
          <RouteWithSubRoutes
            key={i}
            {...route}
            currentUser={currentUser}
            getPartnerPlans={this.props.getPartnerPlans}
            handleIsLoadMore={this.handleIsLoadMore}
            handleLoadMore={this.handleLoadMore}
            handleSelectedPlan={this.handleSelectedPlan}
            partnerPlans={partnerPlans}
            planView={constants.PARTNERPLAN.VIEW.MYPLANS}
            selectedPartner={selectedPartner}
            setErrorMessage={this.props.setErrorMessage}
          />
            ))}
      </Container>
    )
  }
}

const mapStateToProps = state => ({
  errorMessage: state.errorMessage,
  partnerPlans: state.partnerPlans,
  selectedPartner: (Object.keys(state.personalinfos.selectedPartner).length === 0 && sessionStorage.getItem('SelectedPartner') !== null ?
    JSON.parse(sessionStorage.getItem('SelectedPartner')) :
    state.personalinfos.selectedPartner),
})

export default withRouter(connect(mapStateToProps, {
  resetErrorMessage,
  setErrorMessage,
  setSelectedPlan,
  // getPageHtmlContent,
  getPartnerPlans,
  initHtmlPageContent,
  updatePartnerPlanStatus,
})(MyPartnerPlans))



// WEBPACK FOOTER //
// ./src/containers/MyPartnerPlans.js